/* tslint:disable */
/* eslint-disable */
/**
 * Survey
 * 現地調査用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCostcoProducts200ResponseAllOfData } from './GetCostcoProducts200ResponseAllOfData';
import {
    GetCostcoProducts200ResponseAllOfDataFromJSON,
    GetCostcoProducts200ResponseAllOfDataFromJSONTyped,
    GetCostcoProducts200ResponseAllOfDataToJSON,
} from './GetCostcoProducts200ResponseAllOfData';

/**
 * 
 * @export
 * @interface SearchCostcoProducts200ResponseAllOf
 */
export interface SearchCostcoProducts200ResponseAllOf {
    /**
     * 
     * @type {GetCostcoProducts200ResponseAllOfData}
     * @memberof SearchCostcoProducts200ResponseAllOf
     */
    data?: GetCostcoProducts200ResponseAllOfData;
}

/**
 * Check if a given object implements the SearchCostcoProducts200ResponseAllOf interface.
 */
export function instanceOfSearchCostcoProducts200ResponseAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SearchCostcoProducts200ResponseAllOfFromJSON(json: any): SearchCostcoProducts200ResponseAllOf {
    return SearchCostcoProducts200ResponseAllOfFromJSONTyped(json, false);
}

export function SearchCostcoProducts200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchCostcoProducts200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : GetCostcoProducts200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function SearchCostcoProducts200ResponseAllOfToJSON(value?: SearchCostcoProducts200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCostcoProducts200ResponseAllOfDataToJSON(value.data),
    };
}

